import type { Field } from './field';

const BUILTIN_FIELDS: Record<string, string> = {
  description: 'description',
  attachments: 'attachments',
};

export const getFormFields = (
  rawFields: string[] | undefined,
  catalogFields: Record<string, Field> = {}
): string[] => {
  const fieldMap: Record<string, string> = {
    ...BUILTIN_FIELDS,
    ...Object.fromEntries(
      Object.values(catalogFields).flatMap((field) => [
        [field.label.toLowerCase(), field.id],
        [field.id.toLowerCase(), field.id],
      ])
    ),
  };
  return (rawFields ?? [])
    .map((f) => fieldMap[f?.trim().toLowerCase()])
    .filter((id): id is string => id !== undefined);
};
